import React, { useState } from 'react';
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Grid, makeStyles, Typography, Button, TableContainer, Table, TableHead, TableRow, TableCell, Box, TableBody, Paper, Switch } from '@material-ui/core';
import { ArrowBack, MonetizationOn } from '@material-ui/icons';
import { NumberInput, SimpleForm, SaveButton, Toolbar, BooleanInput } from 'react-admin';
import { useForm, useFormState } from 'react-final-form';
import axios from 'axios';
import CustomSchoolSelect from '../Signet/CustomSchoolSelect';
import { PreciousRingMaterials } from '../Signet/util';
import { validatePositiveNumber, validateRequired } from '../../utils/Validations';
import baseURL from '../../settings';

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  title: {
    marginBottom: theme.spacing(3),
    paddingLeft: theme.spacing(2),
  },
}));

const CustomToolbar = props => {
    const { getState } = useForm();
    const { hasValidationErrors, values } = useFormState();

    const handleSubmit = async () => {
      const formValues = getState().values;
      if (props.isVolume) {
        delete formValues.weight;
      } else {
        delete formValues.volume;
      }
      const res = await axios.post(`${baseURL.apiBaseUrl}/fetch-precious-price`, formValues)
      props?.setData(res.data);
  };

    return (
        <Toolbar {...props}>
            <SaveButton
                label="Price"
                icon={<MonetizationOn/>}
                disabled={hasValidationErrors || props.data}
                handleSubmitWithRedirect={handleSubmit}
            />
        </Toolbar>
    );
};

const PreciousPricingCalculator = () => {
  const classes = useStyles();
  const [data, setData] = useState(null);
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return (
    <Card style={{ overflow: 'visible' }}>
      <CardContent>
        <Typography variant="h5" className={classes.title}>
          Precious Pricing Calculator
        </Typography>
        <SimpleForm toolbar={<CustomToolbar data={data} setData={setData} isVolume={checked} />}>
          <Grid container className={classes.container} justify="space-between">
            <Grid item xs={12} style={{display: 'flex', gap: '6px', alignItems: 'center'}}>
              <Typography>Weight</Typography>
              <Switch checked={checked} onChange={handleChange} disabled={data}/>
              <Typography>Volume</Typography>
            </Grid>
            <Grid item xs={5}>
              <p className="label">Material</p>
              <CustomSchoolSelect source="ring_material" isDisabled={data} resource={PreciousRingMaterials} validate={[validateRequired]} fullWidth />
            </Grid>
            <Grid item xs={5}>
              <NumberInput label={checked ? 'Volume' : "Weight"} source={checked ? 'volume' : "weight"} disabled={data} defaultValue="0" validate={[validateRequired,validatePositiveNumber]} fullWidth />
            </Grid>
          </Grid>
        </SimpleForm>

        {data && (<div className="mt-6">
          <Button style={{ alignSelf: 'flex-start' }} onClick={() => setData(null)} variant="text" color="primary">
            <ArrowBack />
            Back
          </Button>
          <Box sx={{ width: '100%', display: 'flex', gap: 10, flexDirection: 'column' }}>
              <Typography align="left" variant="h4">Details </Typography>
              <TableContainer component={Paper}>
                  <Table size="small" aria-label="Price Breakdown">
                      <TableHead>
                          <TableRow>
                              <TableCell />
                              <TableCell>Label</TableCell>
                              <TableCell>Value</TableCell>

                          </TableRow>
                      </TableHead>
                      <TableBody>
                          <TableRow>
                              <TableCell>{1}</TableCell>
                              <TableCell>Ring Material</TableCell>
                              <TableCell><b>{data?.ring_material}</b></TableCell>
                          </TableRow>
                          <TableRow>
                              <TableCell>{2}</TableCell>
                              <TableCell>Volume</TableCell>
                              <TableCell><b>{data?.volume}</b></TableCell>
                          </TableRow>
                          <TableRow>
                              <TableCell>{3}</TableCell>
                              <TableCell>Weight</TableCell>
                              <TableCell><b>{data?.weight}</b></TableCell>
                          </TableRow>
                          <TableRow>
                              <TableCell>{4}</TableCell>
                              <TableCell>Density</TableCell>
                              <TableCell><b>{data?.density}</b></TableCell>
                          </TableRow>
                          <TableRow>
                              <TableCell>{5}</TableCell>
                              <TableCell>Price</TableCell>
                              <TableCell><b>{data?.price}</b></TableCell>
                          </TableRow>
                      </TableBody>
                  </Table>
              </TableContainer>
          </Box>
        </div>)}

      </CardContent>
    </Card>
  );
}

export default PreciousPricingCalculator